export enum JobType {
  TerrainMesh1TileFloorTexture = 1,
  TerrainMesh1TileFloorQuadrantLowTexture,
  StaticNoiseTexture,
  GrassWavesGeometry,
  GrittyCamoMapTexture3,
  NoiseNormalMapTexture,
}